import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface NewContractProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class NewContract extends React.Component<NewContractProps> {

    @observable private contract: any = {
        client_id: "",
        package_id: "",
        reference: "",
        reference_phone: "",
        reference_relationship: "",
        other_phones: "",
        address_street: "",
        address_colonia: "",
        address_interior: "",
        address_exterior: "",
        address_zipcode: "",
        address_reference: "",
        payment_type: "",
        house_type: "",
        collection_time: "",
        cutoff_date_id: "",
        notes_creation: "",
        rfc: "",
        razon_social: "",
        regimen_fiscal: "",
        uso_cfdi: "",
        factura_calle: "",
        factura_colonia: "",
        factura_interior: "",
        factura_exterior: "",
        factura_ciudad: "",
        factura_estado: "",
        factura_cp: "",
    };
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private clients: any = [];
    @observable private client: any;
    @observable private packages: any = [];
    @observable private cutoffs: any = [];
    @observable private payment_types = [
        { id: "COBRADOR", name: "Cobrador" },
        { id: "DEPOSITO", name: "Deposito" },
        { id: "TRANSFERENCIA", name: "Transferencia" }
    ]
    @observable private house_types = [
        { id: "Propia", name: "Propia" },
        { id: "Renta", name: "Renta" }
    ]
    @observable private usos_cfdi = [
        { id: "G01", name: "G01 - Adquisición de mercancías" },
    { id: "G02", name: "G02 - Devoluciones, descuentos o bonificaciones" },
    { id: "G03", name: "G03 - Gastos en general" },
    { id: "I01", name: "I01 - Construcciones" },
    { id: "I02", name: "I02 - Mobiliario y equipo de oficina por inversiones" },
    { id: "I03", name: "I03 - Equipo de transporte" },
    { id: "I04", name: "I04 - Equipo de cómputo y accesorios" },
    { id: "I05", name: "I05 - Dados, troqueles, moldes, matrices y herramental" },
    { id: "I06", name: "I06 - Comunicaciones telefónicas" },
    { id: "I07", name: "I07 - Comunicaciones satelitales" },
    { id: "I08", name: "I08 - Otra maquinaria y equipo" },
    { id: "D01", name: "D01 - Honorarios médicos, dentales y gastos hospitalarios" },
    { id: "D02", name: "D02 - Gastos médicos por incapacidad o discapacidad" },
    { id: "D03", name: "D03 - Gastos funerales" },
    { id: "D04", name: "D04 - Donativos" },
    { id: "D05", name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)" },
    { id: "D06", name: "D06 - Aportaciones voluntarias al SAR" },
    { id: "D07", name: "D07 - Primas por seguros de gastos médicos" },
    { id: "D08", name: "D08 - Gastos de transportación escolar obligatoria" },
    { id: "D09", name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones" },
    { id: "D10", name: "D10 - Pagos por servicios educativos (colegiaturas)" },
    { id: "CP01", name: "CP01 - Pagos" },
    { id: "CN01", name: "CN01 - Nómina" },
    { id: "S01", name: "S01 - Sin efectos fiscales" }
    ];
    @observable private regimen_fiscal = [
        { id: "605", name: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios" },
        { id: "626", name: "626 - Régimen Simplificado de Confianza (RESICO)" },
        { id: "612", name: "612 - Actividades Empresariales y Profesionales" },
        { id: "606", name: "606 - Régimen de Arrendamiento" },
        { id: "625", name: "625 - Régimen de Actividades Empresariales con Ingresos a través de Plataformas Tecnológicas" },
        { id: "607", name: "607 - Régimen de Enajenación o Adquisición de Bienes" },
        { id: "608", name: "608 - Régimen de los Demás Ingresos" },
        { id: "611", name: "611 - Ingresos por Dividendos (Socios y Accionistas)" },
        { id: "614", name: "614 - Ingresos por Intereses" },
        { id: "615", name: "615 - Ingresos por Obtención de Premios" },
        { id: "621", name: "621 - Régimen de Incorporación Fiscal (RIF)" },
        { id: "616", name: "616 - Sin Obligaciones Fiscales" },
        { id: "601", name: "601 - Régimen General de Ley Personas Morales" },
        { id: "626", name: "626 - Régimen Simplificado de Confianza (RESICO) para Personas Morales" },
        { id: "603", name: "603 - Personas Morales con Fines no Lucrativos" },
        { id: "620", name: "620 - Sociedades Cooperativas de Producción que Optan por Diferir sus Ingresos" },
        { id: "622", name: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
        { id: "623", name: "623 - Régimen Opcional para Grupos de Sociedades" },
        { id: "624", name: "624 - Coordinados" }
    ];

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;

        http.get(`/api/client/readAll`).then((response) => {
            this.clients = response.data.response;
            this.client = this.clients.find((element: any) => {
                return element.id === id;
            });
            if (this.client) {
                this.contract.client_id = this.client.id;
            }
        })
            .then(() => {
                return http.get(`/api/package/read`).then((response) => {
                    this.packages = response.data.response;
                })
            })
            .then(() => {
                return http.get(`/api/cutoff/read`).then((response) => {
                    this.cutoffs = response.data.response;
                    const today = new Date().getDate();
                    const nextCutOff = this.getNextCutOff(this.cutoffs, today);
                    this.contract.cutoff_date_id = nextCutOff.id;
                    this.isLoaded = true;
                })
            })
            .catch((error) => {
                toast.error("Error cargando Informacion");
            });
    }

    private getNextCutOff = (array:any, val:any) =>{
        for (var i=0; i < array.length; i++) {
            if (Number(array[i].date) > val) {
                return array[i];
            }
            if(i === array.length - 1) {
                return array[0];
            }
        }
      }

      private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.contract[name] = value;
    }

    private additionalCost = ():number => {
        const todayDate = new Date();
        const today = todayDate.getDate();
        const todayMonth = todayDate.getMonth() + 1;
        const todayYear = todayDate.getFullYear();
        const cutOffDay = this.cutoffs.filter((e:any) =>{
            return Number(e.id) === Number(this.contract.cutoff_date_id);
        });
        let days = 0;
        const fechaDeCorte = cutOffDay[0].date === "31" ? (new Date(todayYear, todayMonth-1, 0)).getDate() : cutOffDay[0].date;
        if(today > fechaDeCorte) {
            //Generamos la fecha de hoy del siguiente mes
            const dateCorte= new Date(todayYear, todayMonth, fechaDeCorte); 
            const hoySinSegundos= new Date(todayYear,todayMonth -1,today); 
            const diferenciaSegundos = dateCorte.getTime() - hoySinSegundos.getTime(); 
            // To calculate the no. of days between two dates 
            days = diferenciaSegundos / (1000 * 3600 * 24); 
            days = Math.floor(days);
            //Calcular dias entre hoy y la fecha de corte cuando es el siguiente mes
        } else { //La fecha es este mes
            days = fechaDeCorte - today;
        }

        if(days > 5) {
            const costo = this.contract.package_id !== "" ? this.packages.find((x: any) => x.id === this.contract.package_id).cost : "0";
            
            return days * (Math.floor(costo/30));
        }
        return 0;
    };
    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private getTotal = () => {
        const renta = this.contract.house_type === "Renta" ? 300 : 0;
        return Number(this.packages.find((x: any) => x.id === this.contract.package_id).cost) + 300 + this.additionalCost() + renta;
    }

    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        // eslint-disable-next-line
        this.contract.reference_phone = this.contract.reference_phone.replace(/\-/g, '');
        this.contract.created_by = sessionService.getUserInfo().id;
        this.contract.total = this.getTotal();

        http.post(`/api/contract/create`, JSON.stringify(this.contract))
            .then(() => {
                toast.success(`Contrato agregado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        if (this.redirect) {
            return <Redirect to="/contratos" />
        }
        return (
          <Fragment>
            <div className="row">
              <div className="col-md-8">
                <div className="card">
                  <div className="card-header card-header-rose card-header-text">
                    <div className="card-text">
                      <h4 className="card-title">
                        Contrato nuevo{" "}
                        {this.client && <span>para {this.client.name}</span>}
                      </h4>
                    </div>
                  </div>
                  <div className="card-body ">
                    <div className="row">
                      <div className="col-sm-10"></div>
                      <div className="col-sm-2">
                        <Link to={`/contratos`}>
                          <button className="btn btn-danger btn-sm  pull-right">
                            <i className="material-icons">highlight_off</i>
                            <div className="ripple-container"></div>
                          </button>
                        </Link>
                      </div>
                    </div>
                    {!this.client && (
                      <InputForm
                        name="client_id"
                        label="Cliente"
                        value={this.contract.client_id}
                        setValidation={this.setValidation}
                        required={true}
                        onChange={this.handleChange}
                        type="select"
                        options={this.clients}
                      />
                    )}
                    <InputForm
                      name="package_id"
                      label="Paquete"
                      value={this.contract.package_id}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.packages}
                      disabled={false}
                    />
                    <InputForm
                      name="other_phones"
                      label="Otros teléfonos"
                      value={this.contract.other_phones}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="reference"
                      label="Referencia"
                      value={this.contract.reference}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="reference_phone"
                      label="Teléfono de Referencia"
                      value={this.contract.reference_phone}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      format={"###-###-####"}
                    />
                    <InputForm
                      name="reference_relationship"
                      label="Relación de Referencia"
                      value={this.contract.reference_relationship}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_street"
                      label="Dirección del Contrato"
                      value={this.contract.address_street}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_colonia"
                      label="Colonia"
                      value={this.contract.address_colonia}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_interior"
                      label="Número Interior"
                      value={this.contract.address_interior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_exterior"
                      label="Número Exterior"
                      value={this.contract.address_exterior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_zipcode"
                      label="Codigo Postal"
                      value={this.contract.address_zipcode}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      format={"#####"}
                    />
                    <InputForm
                      name="address_reference"
                      label="Referencias del lugar"
                      value={this.contract.address_reference}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="house_type"
                      label="Tipo de Casa"
                      value={this.contract.house_type}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.house_types}
                    />
                    <InputForm
                      name="payment_type"
                      label="Forma de Pago"
                      value={this.contract.payment_type}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.payment_types}
                    />
                    <InputForm
                      name="collection_time"
                      label="Horario de cobro preferido"
                      value={this.contract.collection_time}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="cutoff_date_id"
                      label="Fecha de Corte"
                      value={this.contract.cutoff_date_id}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.cutoffs.map((value: any) => {
                        return {
                          id: value.id,
                          name:
                            "Dia " +
                            value.date +
                            " - (" +
                            value.contracts +
                            " contratos)",
                        };
                      })}
                    />
                    <InputForm
                      name="notes_creation"
                      label="Notas (Max: 255 caracteres)"
                      value={this.contract.notes_creation}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="textarea"
                      maxLength={255}
                    />
                    <div className="row">
                      <div className="col-sm-12 text-center">
                        <h4 className="card-title">Datos fiscales</h4>
                        <h6 className="card-subtitle">
                          Si no tiene RFC, dejar en blanco
                        </h6>
                      </div>
                    </div>
                    <InputForm
                      name="rfc"
                      label="RFC"
                      value={this.contract.rfc}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="razon_social"
                      label="Razón Social"
                      value={this.contract.razon_social}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="regimen_fiscal"
                      label="Régimen Fiscal"
                      value={this.contract.regimen_fiscal}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.regimen_fiscal}
                    />
                    <InputForm
                      name="uso_cfdi"
                      label="Uso De CFDI"
                      value={this.contract.uso_cfdi}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.usos_cfdi}
                    />
                    <InputForm
                      name="factura_calle"
                      label="Calle"
                      value={this.contract.factura_calle}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_colonia"
                      label="Colonia"
                      value={this.contract.factura_colonia}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_interior"
                      label="Número Interior (Dejar en blanco si no aplica)"
                      value={this.contract.factura_interior}
                      setValidation={this.setValidation}
                      required={false}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_exterior"
                      label="Número Exterior"
                      value={this.contract.factura_exterior}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_ciudad"
                      label="Ciudad"
                      value={this.contract.factura_ciudad}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_estado"
                      label="Estado"
                      value={this.contract.factura_estado}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="factura_cp"
                      label="Código Postal"
                      value={this.contract.factura_cp}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <button
                      onClick={this.onSubmit}
                      type="submit"
                      className="btn btn-primary pull-right"
                    >
                      Crear contrato
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <div className="card-header card-header-rose card-header-text">
                    <div className="card-text">
                      <h4 className="card-title">Costo de instalación</h4>
                    </div>
                  </div>
                  <div className="card-body ">
                    <h3>-Cobro instalación: $300</h3>
                    {this.contract.house_type === "Renta" && (
                      <h3>-Casa de Renta: $300</h3>
                    )}
                    <h3>
                      -Paquete{" "}
                      {this.contract.package_id !== ""
                        ? this.packages.find(
                            (x: any) => x.id === this.contract.package_id
                          ).cost
                        : "$0"}
                    </h3>
                    <h3>-Costo dias extra ${this.additionalCost()}</h3>
                    <h2 style={{ textAlign: "right" }}>
                      Total: $
                      {this.contract.package_id !== ""
                        ? this.getTotal()
                        : "300"}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
    }
}